<template>
  <div class="upload-section__uploaded-image">
    <img
      :src="uploadedArtwork.artwork.square.url"
      alt="Uploaded Artwork Thumbnail"
    />
    <button @click="removeArtwork" class="uploaded-image__remove-button">
      <span class="screenreader">Remove</span>
      <span class="icon icon--upload-remove" aria-label="Upload Remove"></span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    uploadedArtwork: {
      type: Object,
      required: true,
    },
  },
  methods: {
    removeArtwork() {
      // Emit an event to the parent component
      this.$emit('removeArtwork', this.uploadedArtwork);
    },
  },
};
</script>
